interface Product {
    id: string;
    name: string;
    description: string;
    priceInCents: number;
    priceId: string;
    imgUrl: string;
    quantity: number;
    reccoPhoto: string; 
    shipDate?: string;
    sizes?: string[];
    soldOutSizes?: string[];
}

class Product implements Product {
    id: string;
    name: string;
    description: string;
    priceInCents: number;
    priceId: string;
    imgUrl: string;
    quantity: number;
    reccoPhoto: string; 
    shipDate?: string;
    sizes?: string[];
    soldOutSizes?: string[];

    constructor(
        id: string,
        name: string,
        description: string,
        priceInCents: number,
        priceId: string, 
        imgUrl: string,
        quantity: number,
        reccoPhoto: string, 
        shipDate?: string,
        sizes?: string[],
        soldOutSizes?: string[]
) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.priceInCents = priceInCents;
        this.priceId = priceId;
        this.imgUrl = imgUrl;
        this.quantity = quantity;
        this.reccoPhoto = reccoPhoto;
        this.shipDate = shipDate;
        this.sizes = sizes;
        this.soldOutSizes = soldOutSizes;
    }
}

// New 2025 T-shirt line
const FIFTY_SIX_BREWING_SHIRT = new Product(
    'prod_TP5Qruo46TawO',
    'TURTLE SOCIAL x 56 BREWING',
    'Adult T-shirt, green tie-die with dark green print',
    3000,
    'price_1SSQavFN7W3wvsvNhUB0N9LM',
    'https://turtl-web-images.azureedge.net/website/56-brewing-shirt.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/56-brewing-shirt.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
);

const CLASSIC_ADULT_SHIRT = new Product(
    'prod_TP4kZGEK1n1xSe',
    'TURTLTRACKER CLASSIC ADULT',
    'Adult T-shirt, dark green with light green print',
    3000,
    'price_1SSQYHFN7W3wvsvNHXpIEVWb',
    'https://turtl-web-images.azureedge.net/website/classic-shirt.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/classic-shirt.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
);

const CLASSIC_YOUTH_SHIRT = new Product(
    'prod_TP3AwraFmrNFn',
    'TURTLTRACKER CLASSIC YOUTH',
    'Kids T-shirt, dark green with light green print',
    2000,
    'price_1SSQZSFN7W3wvsvNqw87c41X',
    'https://turtl-web-images.azureedge.net/website/classic-shirt.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/classic-shirt.jpg',
    undefined,
    ['kids XS', 'kids S', 'kids M', 'kids L', 'kids XL'],
);

const GREEN_CREW = new Product(
    'prod_ROA39UFFrPsUOy',
    'EMBROIDERED CLASSIC CREW',
    'Pond slider green',
    5500,
    "price_1QVNjlFN7W3wvsvNapYOFEpi",
    'https://turtl-web-images.azureedge.net/website/green-crew-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/sweatshirt-green-mobile.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
); 

const EGGSHELL_CREW = new Product(
    'prod_ROA0rvO0Q0yXAi',
    'EMBROIDERED CLASSIC CREW',
    'Eggshell',
    5500,
    "price_1QVNgKFN7W3wvsvNjFbHTcM3",
    'https://turtl-web-images.azureedge.net/website/eggshell-crew-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/sweatshirt-eggshell-mobile.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
);

const LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT = new Product(
    'prod_SQFAiKCkrEioME',
    'LOOK OUT FOR THE LITTLE GUYS',
    'Kids T-shirt, green with dark green print',
    2000,
    "price_1RVOg5FN7W3wvsvNSbLGXMN5",
    'https://turtl-web-images.azureedge.net/website/kids-t.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/kids-t.jpg',
    undefined,
    ['kids XS', 'kids S', ' kids M', 'kids L', 'kids XL'],
    ['kids XS', 'kids S', ' kids M', 'kids XL'],
);

const SLOW_AND_STEADY_T_SHIRT = new Product(
    'prod_SQFBhQegJSKGoB',
    'SLOW AND STEADY',
    'Adult T-shirt, eggshell with dark green print',
    3000,
    "price_1RVOh0FN7W3wvsvNyDhuzpcf",
    'https://turtl-web-images.azureedge.net/website/blandings-shirt.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/blandings-shirt.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
    ['S', 'M', 'L'],
);

const START_SEEING_TURTLES_T_SHIRT = new Product(
    'prod_SQF9iNXGRxqDtQ',
    'START SEEING TURTLES',
    'Adult T-shirt, white with dark green print',
    3000,
    "price_1RVOfGFN7W3wvsvNizJKHEi4",
    'https://turtl-web-images.azureedge.net/website/start-seeing-turtles.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/start-seeing-turtles.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
);

const TURTLE_RESCUE_CLUB_T_SHIRT = new Product(
    'prod_SQF8DhboAjXbAM',
    'TURTLE RESCUE CLUB',
    'Adult T-shirt, tie-die with dark green print',
    3000,
    "price_1RVOeNFN7W3wvsvNJYgcX5w3",
    'https://turtl-web-images.azureedge.net/website/turtl-rescue-club.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/turtl-rescue-club.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
    ['S', 'M'],
);

const TURTLE_CROSSING_PIN = new Product(
    'prod_SQFDO1sXhZjIcN',
    'TURTLE CROSSING PIN',
    'Standard',
    1000,
    'price_1RVOiyFN7W3wvsvNrqSz54Rt',
    'https://turtl-web-images.azureedge.net/website/turtl-crossing-pin.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/turtl-crossing-pin.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const MN_PIN = new Product(
    'prod_SQFE7MB4EuZ5dy',
    'TURTLE RESCUE CLUB PIN',
    '',
    1000,
    'price_1RVOjgFN7W3wvsvNRbIw7mYR',
    'https://turtl-web-images.azureedge.net/website/mn-pin.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/mn-pin.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const WHEAT_HAT = new Product(
    'prod_RPGHVBvdsSDAPO',
    'TURTLTRACKER X LOCALE',
    'Daily Pine beanie, wheat',
    3500,
    "price_1QWRkSFN7W3wvsvNmfHVw5og",
    'https://turtl-web-images.azureedge.net/website/wheat-hat-4.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-wheat-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const SAGE_HAT = new Product(
    'prod_RPGGi55hXAWWs7',
    'TURTLTRACKER X LOCALE',
    'Highline beanie, sage',
    3500,
    "price_1QWRjrFN7W3wvsvNXPSzcg7h",
    'https://turtl-web-images.azureedge.net/website/sage-hat-4.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-sage-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const WHITE_HAT = new Product(
    'prod_RPG79AY9CfAPyn',
    'TURTLTRACKER X LOCALE',
    'Frosted Slife beanie, white',
    4500,
    "price_1QWRb4FN7W3wvsvNnMc0GAoD",
    'https://turtl-web-images.azureedge.net/website/white-hat-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-white-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const BLACK_HAT = new Product(
    'prod_RPGAL8SZp7lIM8',
    'TURTLTRACKER X LOCALE',
    'Frosted Slife beanie, black',
    4500,
    "price_1QWRduFN7W3wvsvNTOBzQnTm",
    'https://turtl-web-images.azureedge.net/website/black-hat-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-black-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const SOCKS = new Product(
    'prod_S0LyP6C3ZFDXUh',
    'TURTLTRACKER X HIPPY FEET',
    'Protect the Locals socks',
    2000,
    'price_1R6LGkFN7W3wvsvN0wYy34BL',
    'https://turtl-web-images.azureedge.net/website/EGGSHELL-SOCKS.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/EGGSHELL-SOCKS.jpg',
    undefined,
    ['S','L'],
);

const GREEN_CREW_DEV = new Product(
    'prod_ReyuHNWp1OwGpI',
    'EMBROIDERED CLASSIC CREW',
    'Pond slider green',
    5500,
    "price_1QlewnFN7W3wvsvN5b8m6681",
    'https://turtl-web-images.azureedge.net/website/green-crew-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/sweatshirt-green-mobile.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
); 

const EGGSHELL_CREW_DEV = new Product(
    'prod_ReyvVMcuOzQoni',
    'EMBROIDERED CLASSIC CREW',
    'Eggshell',
    5500,
    "price_1QlexXFN7W3wvsvNEw0TqvI5",
    'https://turtl-web-images.azureedge.net/website/eggshell-crew-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/sweatshirt-eggshell-mobile.jpg',
    undefined,
    ['S', 'M', 'L', 'XL', 'XXL'],
);

const WHEAT_HAT_DEV = new Product(
    'prod_ReyoGvsK4uKMgv',
    'TURTLTRACKER X LOCALE',
    'Daily Pine beanie, wheat',
    3500,
    "price_1QleqrFN7W3wvsvN4dcjpLQf",
    'https://turtl-web-images.azureedge.net/website/wheat-hat-4.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-wheat-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const SAGE_HAT_DEV = new Product(
    'prod_ReysO6vLAQyNLL',
    'TURTLTRACKER X LOCALE',
    'Highline beanie, sage',
    3500,
    "price_1QleuWFN7W3wvsvNwTE4jKXu",
    'https://turtl-web-images.azureedge.net/website/sage-hat-4.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-sage-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const WHITE_HAT_DEV = new Product(
    'prod_ReytOE6x6ySxF1',
    'TURTLTRACKER X LOCALE',
    'Frosted Slife beanie, white',
    4500,
    "price_1Qlew7FN7W3wvsvNI509m25v",
    'https://turtl-web-images.azureedge.net/website/white-hat-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-white-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);

const BLACK_HAT_DEV = new Product(
    'prod_ReytlZnX5GjCDa',
    'TURTLTRACKER X LOCALE',
    'Frosted Slife beanie, black',
    4500,
    "price_1QlevWFN7W3wvsvNpTOPd68W",
    'https://turtl-web-images.azureedge.net/website/black-hat-3.jpg',
    1,
    'https://turtl-web-images.azureedge.net/website/hat-black-mobile.jpg',
    undefined,
    ['Standard, one size fits all'],
);




const PRODUCTS_DEV: Product[] = [
    GREEN_CREW_DEV,
    EGGSHELL_CREW_DEV,
    WHEAT_HAT_DEV,
    SAGE_HAT_DEV,
    WHITE_HAT_DEV,
    BLACK_HAT_DEV,
];


const PRODUCTS: Product[] = [
    FIFTY_SIX_BREWING_SHIRT,
    CLASSIC_ADULT_SHIRT,
    CLASSIC_YOUTH_SHIRT,
    TURTLE_RESCUE_CLUB_T_SHIRT,
    SLOW_AND_STEADY_T_SHIRT,
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    START_SEEING_TURTLES_T_SHIRT,
    TURTLE_CROSSING_PIN,
    MN_PIN,
    SOCKS,
    GREEN_CREW,
    EGGSHELL_CREW,
    WHEAT_HAT,
    SAGE_HAT,
    WHITE_HAT,
    BLACK_HAT,
];


export {
    FIFTY_SIX_BREWING_SHIRT,
    CLASSIC_ADULT_SHIRT,
    CLASSIC_YOUTH_SHIRT,
    GREEN_CREW_DEV,
    EGGSHELL_CREW_DEV,
    WHEAT_HAT_DEV,
    SAGE_HAT_DEV,
    WHITE_HAT_DEV,
    BLACK_HAT_DEV, 
    GREEN_CREW,
    EGGSHELL_CREW,
    WHEAT_HAT,
    SAGE_HAT,
    WHITE_HAT,
    BLACK_HAT,
    SOCKS,
    TURTLE_RESCUE_CLUB_T_SHIRT,
    SLOW_AND_STEADY_T_SHIRT,
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    START_SEEING_TURTLES_T_SHIRT,
    TURTLE_CROSSING_PIN, 
    MN_PIN,
    PRODUCTS_DEV, 
};

export type { Product };
export default PRODUCTS;
